import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cartReducer";
import "./Card.scss";
import axios from "axios";
import { toast } from "react-toastify";
import { IoIosInformationCircleOutline } from "react-icons/io";

const Card = ({ item }) => {
  const [showNotify, setShowNotify] = useState(false);
  const [selectItem, setSelectItem] = useState("");
   const [notify,setNotify] = useState("")
     const [email,setEmail] = useState("")
     const [quantity, setQuantity] = useState(1);

  const dispatch = useDispatch();

 const cartItem = useSelector((state) =>
   state.cart.products.find((i) => i.id === item._id)
 );
 const cartQuantity = cartItem?.quantity || 0; 

  const handleAddToCart = () => {
    if (item.outofstock) {
      toast.error("This product is unavailable");
      return;
    }

    // 1️⃣ Redux add to cart
    dispatch(
      addToCart({
        id: item._id,
        name: item.name,
        desc: item.desc,
        weight: item.weight,
        price: item.price,
        stock: item.stock,
        img: item.proPhotos[0],
        quantity: 1,
        lrCode: item.lrCode,
      })
    );
    toast.success("Added to cart!");

    // 2️⃣ Google Analytics (GA4) event
    if (window.gtag) {
      window.gtag("event", "add_to_cart", {
        currency: "AED",
        value: item.price,
        items: [
          {
            item_id: item._id,
            item_name: item.name,
            price: item.price,
            quantity: 1,
          },
        ],
      });
    }

    // 3️⃣ Meta Pixel event
    if (window.fbq) {
      window.fbq("track", "AddToCart", {
        value: item.price,
        currency: "AED",
        contents: [
          {
            id: item._id,
            quantity: 1,
            item_name: item.name,
          },
        ],
        content_type: "product",
      });
    }
  };

  const showHandleNotify = (item) => {
    setSelectItem(item)
    setShowNotify(true);
  };

   const handleNotify = async () => {
      const data = {
        email,
        lrCode: selectItem.lrCode,
        slug: selectItem.slug,
        name: selectItem.name,
        photo: selectItem.proPhotos[0],
      };
  
      try {
        const response = await axios.post('/notify-me',data);
        setNotify(response.data.message)
      } catch (error) {
        return
      }
    };
  return (
    <div className="card">
      {item.outofstock ? (
        <Link to={`/product/${item.slug}`}>
          <div className="image-wrapper">
            <span className="badge discount">{item.discount}%</span>
            {item.outofstock && <span className="badge out">Out of Stock</span>}

            <img
              src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[0]}`}
              alt={item.name}
              className="mainImg"
            />

            <img
              src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[1]}`}
              alt={item.name}
              className="hoverImg"
            />
          </div>
        </Link>
      ) : (
        <Link to={`/product/${item.slug}`}>
          <div className="image-wrapper">
            <span className="badge discount">{item.discount}%</span>
            {item.outofstock && <span className="badge out">Out of Stock</span>}

            <img
              src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[0]}`}
              alt={item.name}
              className="mainImg"
            />

            <img
              src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[1]}`}
              alt={item.name}
              className="hoverImg"
            />
          </div>
        </Link>
      )}

      <div className="card-content">
        <h3 className="title">{item.name}</h3>
        {/* <p className="weight">SKU:{" "}{item.lrCode}</p> */}
        <div className="bt_wrp">
          <div className="price-section">
            {item.oldPrice && (
              <span className="old-price">
                <em>AED </em>
                {item.oldPrice}
              </span>
            )}
            <span className="price">
              <em>AED</em> {Number(item.price).toFixed(2)}
            </span>
          </div>

          {item.outofstock ? (
            <button
              className="add-btn_notify"
              onClick={() => showHandleNotify(item)}
              //disabled={item.outofstock}
            >
              Notify me
            </button>
          ) : (
            <button
              className="add-btn"
              onClick={() => {
                if (1 + cartQuantity > item.stock) {
                  import("react-toastify").then(({ toast }) =>
                    toast.warning(`Only ${item.stock} pcs available`)
                  );
                  return;
                }
                handleAddToCart();
                
              }}
              disabled={item.stock < 1}
            >
              Add to Cart
            </button>
          )}
        </div>

        {item.outofstock && (
          <div className="noti_msg">
            <span>Get Notified When This Product Is Back in Stock</span>
          </div>
        )}
        {!notify && (
          <>
            {showNotify && (
              <div className="notify_me">
                <input
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                />
                <button onClick={handleNotify}>Notify</button>
              </div>
            )}
          </>
        )}
        <div className="flashSellBtn">
          {item.flashSale === "yes" && (
            <div className="fls_in">
              <Link to="https://snacksfactory.ae/offers">
                <span>Limited time: This product is on Flash Sale!</span>
              </Link>
            </div>
          )}
        </div>
        {/* {item.outofstock ? (
          <Link className="learn-more">
            <IoIosInformationCircleOutline size={17} color="white" />
          </Link>
        ) : (
          <Link to={`/product/${item.slug}`} className="learn-more">
            <IoIosInformationCircleOutline size={17} color="gray" />
          </Link>
        )} */}
      </div>
    </div>
  );
};

export default Card;
